module.exports = __webpack_public_path__ + "img/button_page down.729d7565.png";